export const REDIRECT_URL_FIELD = 'redirectUrl'
